import type { ApiKeys } from './setApigeeConfig';
import { apigeeConfig } from './setApigeeConfig';

/** Custom apiKeys for addresses API endpoint */
const ADDRESSES_API_KEYS: ApiKeys = {
	'api-test.anwb.nl': 'CTKxhr0Gfpfx4vkne0e9z5U8nHLXLCKn',
	'api-ontw.anwb.nl': 'CTKxhr0Gfpfx4vkne0e9z5U8nHLXLCKn',
	'api-acc.anwb.nl': 'CTKxhr0Gfpfx4vkne0e9z5U8nHLXLCKn',
	'api.anwb.nl': 'BDJj1aXZlnOQHCWFauDi8aV445shP1IS',
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const makeConfig = () => apigeeConfig(ADDRESSES_API_KEYS);

/** Custom ApigeeConfig with apiKeys for the addresses API endpoint */
const addressConfig = makeConfig();

export default addressConfig;
